import { render, staticRenderFns } from "./FCYAxisSettings.vue?vue&type=template&id=09f8aeb8&scoped=true"
import script from "./FCYAxisSettings.vue?vue&type=script&lang=js"
export * from "./FCYAxisSettings.vue?vue&type=script&lang=js"
import style0 from "./FCYAxisSettings.vue?vue&type=style&index=0&id=09f8aeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f8aeb8",
  null
  
)

export default component.exports